"use client";

import { useAuth } from "@/hooks/useAuth";
import { useEffect, useState } from "react";
import AffiliateDashboard from "./AffiliateDashboard";

interface AffiliateContentProps {
  page?: 'dashboard' | 'toolkit';
}

/**
 * Client wrapper that handles auth state for affiliate page.
 *
 * Uses optimistic UI - if user was logged in before, shows dashboard immediately.
 */
export default function AffiliateContent({ page = 'dashboard' }: AffiliateContentProps) {
  const { isLoggedIn } = useAuth();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Hide landing when logged in. The first-paint hide already lives in
  // the inline <script> in page.tsx (id="__ff-affiliate-hide-landing");
  // this effect is the runtime mirror that also tears the style tag down
  // when Privy resolves to logged-out (stale optimistic flag).
  useEffect(() => {
    if (!mounted) return;

    const landing = document.querySelector(".affiliate-landing") as HTMLElement;
    if (!landing) return;

    const inlineStyle = document.getElementById("__ff-affiliate-hide-landing");
    if (isLoggedIn) {
      landing.style.display = "none";
    } else {
      landing.style.display = "";
      if (inlineStyle) inlineStyle.remove();
    }
  }, [mounted, isLoggedIn]);

  if (!mounted) {
    return null;
  }

  if (!isLoggedIn) {
    return null;
  }

  return <AffiliateDashboard currentPage={page} />;
}
